/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Rating, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Testimonio = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderStyle: 'dashed',
                borderColor: theme.palette.secondary.main,
                borderRadius: 1,
                py: 3,
            }}
        >

            <Grid container size={{xs: 12, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Avatar src={item.img} sx={{width: 64, height: 64}}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}> {item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography
                            sx={{fontSize: 14, fontWeight: 400, color: '#00000090'}}> {item.profesion}</Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                        <Rating defaultValue={5}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', mt: 1, px: sCell ? 3 : 0}}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 400,
                            color: '#00000090',
                            textAlign: sCell ? 'center' : 'left'
                        }}>
                            {item.testimonio}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Testimonio